
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProductMasterExcelDialog extends Serenity.PropertyDialog<any, any>
    {
        protected getFormKey() { return ProductMasterExcelForm.formKey; }
        protected getIdProperty() { return ProductMasterRow.idProperty; }
        protected getLocalTextPrefix() { return ProductMasterRow.localTextPrefix; }
        protected getNameProperty() { return ProductMasterRow.nameProperty; }
        protected getService() { return ProductMasterService.baseUrl; }
        protected getInsertPermission() { return ProductMasterRow.insertPermission; }
        protected getUpdatePermission() { return ProductMasterRow.updatePermission; }
        protected getDeletePermission() { return ProductMasterRow.deletePermission; }
        protected useViewMode() { return true; }
        public issues: any[];
        protected form = new ProductMasterExcelForm(this.idPrefix);
        constructor() {
            super();

            this.form = new ProductMasterExcelForm(this.idPrefix);
        }

        protected getDialogTitle(): string {
            return "Excel Import";
        }
        protected getDialogButtons() {
            return [
                {
                    text: 'Import',
                    click: () => {
                        if (!this.validateBeforeSave())
                            return;

                        if (this.form.FileName.value == null ||
                            Q.isEmptyOrNull(this.form.FileName.value.Filename)) {
                            Q.notifyError("Please select a file!");
                            return;
                        }

                        ProductMasterService.ExcelImport({
                            FileName: this.form.FileName.value.Filename
                        }, response => {
                            Q.notifyInfo(
                                'Inserted: ' + (response.Inserted || 0) +
                                ', Updated: ' + (response.Updated || 0));
                            this.issues = response.Issues;
                            if (response.ErrorList != null && response.ErrorList.length > 0) {
                                Q.notifyError(response.ErrorList.join(',\r\n '));
                            }

                            this.dialogClose();
                        }, { async: false });
                        if (this.issues.length > 0) {
                            Q.postToService({
                                service: Common.ExcelImportService.baseUrl + '/IssuesExportExcel',
                                request: {
                                    Issues: this.issues,
                                },

                                target: '_blank'
                            });
                        }

                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }
    }
}